import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Box, Heading, Text, Link, HStack, Image } from "@chakra-ui/react";

const MovieDetail = () => {
  const [singleData, setSingleData] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    const fetchMovie = async () => {
      if (id) {
        const result = await axios.get(
          `https://backendexample.sanbersy.com/api/data-movie/${id}`
        );
        const {
          title,
          description,
          year,
          duration,
          rating,
          review,
          genre,
          image_url,
        } = result.data;
        setSingleData({
          title,
          description,
          genre,
          year,
          review,
          rating,
          duration,
          image: image_url,
        });
      }
    };
    fetchMovie();
  }, []);

  console.log(singleData);

  return (
    <Box p={8}>
      <HStack align="flex-start" spacing="20px">
        <Box>
          <Image
            boxSize="400px"
            objectFit="cover"
            loading="lazy"
            src={singleData.image}
            alt={singleData.title}
          />
        </Box>
        <Box>
          <Heading as="h1" size="lg">
            {singleData.title}
          </Heading>
          <Text>Rating: {singleData.rating} out of 10</Text>
          <Text>Genre: {singleData.genre}</Text>
          <Text>Release Year: {singleData.year}</Text>
          <Text>Duration: {singleData.duration} minutes</Text>
          <Link
            href={`https://www.youtube.com/results?search_query=${singleData.title} trailer`}
            mt={6}
            isExternal
          >
            Watch trailer on Youtube <ExternalLinkIcon mx="2px" />
          </Link>
          <Heading as="h3" size="md" mt={4}>
            Description: {singleData.description}
          </Heading>
          <Heading as="h3" size="md" mt={4}>
            Review: {singleData.review}
          </Heading>
        </Box>
      </HStack>
    </Box>
  );
};

export default MovieDetail;
